import(/* webpackMode: "eager" */ "/vercel/path0/app/karratco/view/profile/[id]/page.tsx");
